<template>
	<div class="btn"><slot></slot></div>
</template>

<script>
	export default {
		name: 'btn'
	}
</script>

<style lang="scss" scoped>

	@import "button-reset.scss";
	@import "media.scss";
	@import "responsive-font.scss";

	.btn {
		&.small {
			a, button, input {
				padding:9px 19px 9px 24px;
			}
		}
		svg {
			width:22px; height:22px; fill:#ffffff; margin-right:4px;
		}
		&.white {
			button, a {
				background:#ffffff; color:#3D3D3D; border:1px solid rgba(#222D39, 0.15);
			}
		}
		&.fit {
			a, button {
				display:inline-block;
			}
		}
	}
	button {
		// @include button-reset;
	}
	a, button, input {
		@include responsive-font(14);
		display:flex; align-items:center; justify-content:center; flex-wrap:wrap; margin:0 auto; font-size:15px; line-height:1.46; font-weight:600; padding:9px 19px 9px 24px; background:#FDB913; border-radius:25rem; color:#ffffff; border:none;
		@include media(xlarge) {
			padding:8px 20px;
		}
	}
	a {
		text-decoration:none;
	}

	body.embed-mode {
		a, button, input {
			background:#0071BC;
			&:hover {
				background:#112E51;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/_global/btn.vue